import _ from 'underscore';
import Backbone from 'backbone';

var ChangeModel = Backbone.Model.extend({
    // tracking sync status of model
    isReady: false,

    isChanged: false,

    constructor: function(props) {
        this.on(
            'sync',
            function() {
                this.isReady = true;
            }.bind(this)
        );
        Backbone.Model.apply(this, arguments);
    },

    save: function(attributes, options) {
        if (this.isChanged) {
            this.isChanged = false;
            return Backbone.Model.prototype.save.call(this, attributes, options);
        }
    },

    set: function(attributes, options) {
        if (this.isReady && !_.isEmpty(attributes) && !(options && options.xhr)) {
            this.isChanged = true;
        }
        return Backbone.Model.prototype.set.call(this, attributes, options);
    },

    hasChanges() {
        return this.isChanged;
    }
});

export default ChangeModel;
